import React, { useContext, useEffect, useState } from 'react';
import { Usercontext } from '../App';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import styles from '../Components/ViewOrder.module.css'; 

export default function ViewOrder() {
    const { userdata } = useContext(Usercontext);

    const [myOrder, setMyOrder] = useState([]);
    const [loading, setLoading] = useState(true); // To handle loading state

    const getData = async () => {
        if (!userdata) return; // Wait for userdata to be available

        try {
            console.log('Fetching orders for:', userdata.uid);
            const collection = await firebase.firestore().collection('Orders').get();

            const filteredOrders = collection.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setMyOrder(filteredOrders);
        } catch (error) {
            console.error('Error fetching orders:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleComplete = async (id) => {
        try {
            await firebase.firestore().collection('Orders').doc(id).delete();
            setMyOrder(myOrder.filter((order) => order.id !== id)); // Remove the order from the state
            console.log(`Order ${id} deleted successfully.`);
        } catch (error) {
            console.error('Error deleting order:', error);
        }
    };

    useEffect(() => {
        getData();
    }, [userdata]); // Run whenever userdata changes

    if (loading) {
        return <h2 className={styles.loading}>Loading your orders...</h2>; // Show a loading state
    }

    return (
        <div className={styles.orderContainer}>
            {myOrder.length > 0 ? (
                <>
                    {myOrder.map((order) => (
                        <div key={order.id} className={styles.card}>
                            <div className={styles.cardBody}>
                                <h4 className={styles.cardTitle}>{order.productName}</h4>
                                <h5 className={styles.cardSubtitle}>{order.segment}</h5>
                                <p className={styles.cardText}>{order.address}</p>
                                <div className={styles.cardDetails}>
                                    <span className={styles.cardPrice}>Price: {order.price}</span>
                                    <span className={styles.cardCapacity}>
                                        Capacity: {order.capacity}
                                    </span>
                                </div>
                                <button
                                    className={styles.completeButton}
                                    onClick={() => handleComplete(order.id)}
                                >
                                    Complete
                                </button>
                            </div>
                        </div>
                    ))}
                </>
            ) : (
                <h2 className={styles.noOrders}>No Order Found</h2>
            )}
        </div>
    );
}
